module.exports = __webpack_public_path__ + "static/media/daphne.f4d4dba8.png";